import Query from '../../../components/Report';

export const query = ({ offset = 0, cluster_id, deleted_urls, user_domain_id }) =>
    new Query('search-urls-clusters-detail-table-manual', {
        offset,
        cluster_id,
        deleted_urls: deleted_urls ? `and url_name NOT IN ${deleted_urls}` : '',
        user_domain_id,
    });
